import { useState, useEffect, useCallback, useContext } from "react";
import "./activity.css";
import { DateTime } from 'luxon';
import { useParams } from 'react-router-dom';
import Header from "../../components/headerAdmin/Header";
import pdfIcon from "../../pages/myTalentCommunity/icons/pdf.svg"
import docIcon from "../../pages/myTalentCommunity/icons/doc.png";
import Backdrop from '@mui/material/Backdrop';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Checkbox from '@mui/material/Checkbox';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import getAllRequitionForCandi from "../../apis/getAllRequitionForCandidates/getAllRequitionForCandidates";
import RecentActivities from "../../components/RecentActivities/RecentActivities.js";
import {
	NotificationManager
} from "react-notifications";
import debounce from 'lodash/debounce';

import { UserTypeContext } from "../../AppRoute";
import { convertDate } from "../../components/AcitivityModal/assistingFunctions";
import config from '../../Config.json';
import CloseIcon from '@mui/icons-material/Close';
import BulkSubmitModal from '../myTalentCommunity/bulkSubmitDialog/BulkSubmitModal';
import { CandidateCard } from '../myTalentCommunity/advanceSearch/CandidateDrawerCard';
import { codeTofield } from "../../components/GlobalAssistingFunctions/GlobalAssistingFunctions";
import DataTable from "../../components/DataTable/DataTable";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Pending from "../../components/Icons/pending";
import Rejected from "../../components/Icons/rejected";
import Approved from "../../components/Icons/approved";
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess";
import ExcelIcon from "../../components/Icons/excelicon";
import SelectList from "../../components/Icons/selectlist"
import RecruiterReassignmentModel from "../../components/recruiterreassignmentmodel/recruiterreassignmentmodel";
import CandidateOwenershipTransfer from "../../apis/candidateownershiptransfer/candidateownershiptransfer"


const { candidateRequisitionStatusCode } = config;
const stylesSx = (theme) => ({
	search: {
		position: 'relative',
		backgroundColor: '#d1e8ff',
		marginLeft: 0,
		width: '70%',
		marginTop: '4px',
		borderRadius: '5px',
		height: '25px',
	},

	buttonForSupport: {
		justifyContent: 'flex-end !important',
		padding: "5px 42px 20px !important",
	},

	searchIcon: {
		height: '100%',
		position: 'absolute',
		pointerEvents: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},

	inputRoot: {
		// Add styles if needed
	},

	profileButton: {
		color: '#fff',
		backgroundColor: '#1885e6',
		width: '70px',
		'&:hover': {
			backgroundColor: '#1885e6',
			opacity: '0.9',
		},
	},

	inputInput: {
		padding: theme.spacing(0, 4),
		paddingLeft: '0px',
		transition: theme.transitions.create('width'),
		width: '100%',
		[theme.breakpoints.up('md')]: {
			width: '20ch',
		},
	},

	title: {
		backgroundImage:
			'linear-gradient(90deg, rgba(49, 179, 248, 1) 0%, rgba(29, 105, 146, 1) 100%) !important',
	},

	btnCancel: {
		width: '120px',
		height: '32px',
		backgroundColor: '#FFFFFF',
		color: '#1885E6',
		border: '1px solid #1885E6',
		pt: '5px',
		fontSize: '15px',
		borderRadius: '3px',
		'&:hover': {
			opacity: 0.8,
			backgroundColor: '#D1E8FF',
		},
	},

	btnSave: {
		width: '120px',
		height: '32px',
		backgroundColor: '#1885E6',
		fontSize: '15px',
		color: '#FFFFFF',
		border: '1px solid #1885E6',
		pt: '5px',
		borderRadius: '3px',
		'&:hover': {
			opacity: 0.8,
		},
	},

	btnExcel: {
		display: 'flex',
		justifyContent: 'space-between',
	},

	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#fff',
	},

	waitingText: {
		ml: '5px',
	},
});

const normalizePhoneNumber = (phoneValue, countryCode) => {
	if (!phoneValue) return "";
	if (phoneValue.includes(countryCode)) return phoneValue
	else return `${countryCode} ${phoneValue}`
};


function normalizeCandidate(raw) {
	const crd = raw?.candidateresumedetails || raw?.candidateRequisitionDetails || {};


	return {
		candidateId: raw.candidateId || crd.candidateId || raw._id,
		_id: raw._id || crd._id || '',
		name: raw.name || crd.name || '',
		emailID: raw.emailID || raw.email || crd.emailID || '',
		email: raw.email || crd.emailID || '',
		phoneNumber: raw.phoneNumber || raw.phone || crd.phoneNumber || '',
		primarySkill: raw.primarySkill || crd.primarySkill || '',
		yr_of_exp: raw.yr_of_exp || crd.yr_of_exp || 0,
		yearsofexp: raw.yearsofexp || '',
		allSkill: raw.allSkill || '',
		allAdditionalSkill: raw.allAdditionalSkill || '',
		country: raw.country || crd.country || '',
		state: raw.state || crd.state || '',
		city: raw.city || crd.city || '',
		fulladdress: raw.fulladdress || '',
		resumeUrl: raw.resumeUrl || (Array.isArray(raw.resumeLink) && raw.resumeLink.length > 0 ? raw.resumeLink[0] : '') || crd.resumeUrl || '',
		resumeLink: raw.resumeLink || crd.resumeLink || [],
		degreeField: raw.degreeField || '',
		degrees: raw.degrees || crd.degrees || [],
		testnames: raw.testnames || '',
		testskills: raw.testskills || '',
		testScores: raw.testScores || '',
		status: raw.status || crd.status || {},
		notes: raw.notes || crd.notes || '',
		isActive: raw.isActive !== undefined ? raw.isActive : (crd.isActive !== undefined ? crd.isActive : true),
		created_at: raw.created_at || crd.created_at || '',
		updated_at: raw.updated_at || crd.updated_at || '',
		candidateresumedetails: raw.candidateresumedetails || undefined,
		candidateRequisitionDetails: raw.candidateRequisitionDetails || undefined,
		recruiterrequisitions: raw.recruiterrequisitions || undefined,
		recruiterData: raw.recruiterData || undefined,
		lastEventStatusCreatedBy: raw.lastEventStatusCreatedBy || undefined,
		eventStatus: raw.eventStatus || crd.eventStatus || [],
		eventDate: raw.eventDate || crd.eventDate || '',
		event_date: raw.event_date || '',
		clientdata: raw.clientdata || undefined,
		requisitiondetails: raw.requisitiondetails || undefined,
		candidateStatus: raw.candidateStatus || undefined,
		...raw
	};
}


const Activity = (props) => {
	const location = useLocation();
	const history = useNavigate();
	const { userType, userRecords } = useContext(UserTypeContext);
	const id = userType === 'Admin' ? location?.state?.id : userRecords?.id;
	const userRecruitmentpartnerId = userType === 'Admin' ? location?.state?.userRecruitmentpartnerId : userRecords?.recruitmentpartnerId;
	const userRole = userType === 'Admin' ? location?.state?.userRole : userRecords?.role?.roleName;
	const userRecrodData = userType === 'Admin' ? location?.state?.userRecords : userRecords;

	const [isExporting, setIsExporting] = useState(false);
	const [isSearching, setIsSearching] = useState(true)
	const [loading, setLoading] = useState(false);
	const [filter, setFilter] = useState(null);
	const [activCount, setactivCount] = useState({});
	const [dataResult, setDataResult] = useState(null);
	const [counts, setCounts] = useState();
	const [curStatus, setCurStatus] = useState(location?.state?.candidateState || "CRS01")
	const { id: requi } = useParams();
	const [isloading, setIsloading] = useState(true);
	const [openTransferModal, setOpenTransferModal] = useState(false);
	const [selectedTransferCandidate, setSelectedTransferCandidate] = useState(null);
	const [isUserDataUpdating, setIsUserDataUpdating] = useState(false);

	const [reAssignmentObj, setReAssignmentObj] = useState({
		reassginedFrom: {},
		reassginedTo: {},
		reassignTeam: {},
		isReassignTeamFetching: false,
		isReassignToOptionFetching: false
	});

	const [reassignRecruiterList, setReassignRecruiterList] = useState([]);
	const [reassignToRecruiterList, setReassignToRecruiterList] = useState([]);

	const debouncedSearch = useCallback(
		debounce(async (id, userType, requi) => {
			setLoading(true);
			let search;
			let user = userType === 'Admin' ? userRole : userType

			let fields = {
				"MIS Operator": "orgId",
				"Recruiter": "recruiterId",
				"Recruitment Leader": "recruitmentLeaderId",
				"Organization Admin": "orgId",
				"Team Leader": "teamLeaderId",
			}
			let payload_data = {
				"candidateStatusCode": Object.values(candidateRequisitionStatusCode),
				"requisitionId": requi,
				"searchData": {},
				"recruitmentpartnerId": userRecruitmentpartnerId,
				"userRecruitmentpartnerId": userRecruitmentpartnerId,
				"userId": userRecords?.id
			}

			if (userType === "Organization Admin" || userType === "MIS Operator" || (userType === "Admin" && userRole === "Organization Admin") || (userType === "Admin" && userRole === "MIS Operator")) {
				payload_data = { ...payload_data, [fields[user]]: userRecruitmentpartnerId }
				search = await getAllRequitionForCandi(payload_data);
			}
			else {
				payload_data = { ...payload_data, [fields[user]]: id }
				search = await getAllRequitionForCandi(payload_data);
			}

			let allCandidates = {}

			Object.values(candidateRequisitionStatusCode).forEach(elem => {
				allCandidates[elem] = []
			})

			if (search?.data?.data?.length > 0) {
				let data = search.data.data

				data?.forEach((elem) => {
					let key = elem?.status?.candidateStatusCode
					allCandidates[key].push(elem)
				})
				allCandidates["all"] = data
				setDataResult(allCandidates);
			}
			else {
				setDataResult(null);
			}
			setLoading(false);
			setIsSearching(false);
			setIsloading(false)

		}, 1000),
		[]
	);

	useEffect(() => {
		setIsSearching(true);
		setDataResult(null);
		debouncedSearch(id, userType, requi)
	}, [])


	const moveCandidate = (candidateActionArr) => {
		let data = { ...dataResult };

		let currentTime = new Date();

		let count = { ...activCount }

		for (let i = 0; i < candidateActionArr.length; i++) {
			if (candidateActionArr[i].isStageChanged) {
				let from = candidateActionArr[i].currentStatus.candidateStatusCode
				let to = candidateActionArr[i].status.candidateStatusCode;
				let email = candidateActionArr[i].email;
				let candidate = data[from]?.filter(elem => elem.email === email)?.at(0)
				for (let field of Object.keys(candidate)) {
					if (field !== "salary") {
						if (field === "eventDate" || field === "startedDate" || field === "displayDate" || field === "endDate") {
							let dateValue = candidateActionArr[i][field] ? new Date(candidateActionArr[i][field]).toISOString() : null;
							let dateData = dateValue ? dateValue.split("T")[0].replace(/-/g, "/") : "";
							candidate[field] = dateData
						}
						else if (candidateActionArr[i][field]) {
							candidate[field] = candidateActionArr[i][field]
						}
					}
				}
				candidate.updated_at = convertDate(currentTime).split("T")[0].replace(/-/g, "/")

				data[from] = data[from]?.filter(elem => elem.email !== email)
				data["all"] = data["all"]?.filter(elem => elem.email !== email)

				if (!candidateActionArr[i]?.isDeleted) {
					data["all"]?.push(candidate)
					data[to]?.push(candidate)
					count[to]++
				}
				count[from]--
			}
		}
		setactivCount(count)
		setDataResult(data)
	}


	const [selectedCandidates, setSelectedCandidates] = useState([]);
	const [drawerOpen, setDrawerOpen] = useState(false);
	const [openBukSubmitModal, setOpenBukSubmitModal] = useState(false);

	const handleDrawerOpen = () => setDrawerOpen(true);
	const handleDrawerClose = () => setDrawerOpen(false);

	const handleRemoveCandidate = (candidateId) => {
		setSelectedCandidates(prev => prev.filter(item => (item.candidateId || item._id) !== candidateId));
	};

	const handleBulkSubmit = () => {
		handleDrawerClose();
		setOpenBukSubmitModal(true);
	};

	const calculateDaysSinceUpdate = (row) => {
		const { candidaterequisitionattachments } = row.original;
		if (
			candidaterequisitionattachments &&
			candidaterequisitionattachments.approvalStatus?.isPending
		) {
			const updatedAt = DateTime.fromISO(candidaterequisitionattachments.updated_at);
			if (!updatedAt.isValid) return 'N/A';
			const currentDate = DateTime.now();
			const daysDiff = Math.floor(currentDate.diff(updatedAt, 'days').days);
			return daysDiff >= 0 ? `${daysDiff} day${daysDiff !== 1 ? 's' : ''}` : 'N/A';
		}
		return 'N/A';
	};

	const handleCheckboxChange = (props) => {
		const dataItem = normalizeCandidate(props.original);
		const candidateId = dataItem.candidateId;
		setSelectedCandidates(prev => {
			const alreadySelected = prev.find(item => item.candidateId === candidateId);
			if (alreadySelected) {
				return prev.filter(item => item.candidateId !== candidateId);
			} else {
				if (prev.length < 5) {
					return [...prev, dataItem];
				} else {
					alert("You can select up to 5 candidates only.");
					return prev;
				}
			}
		});
	};


	const handleCandidateLink_candidatesearch = (props) => {
		const candidateId = normalizeCandidate(props.original).candidateId;
		const isChecked = selectedCandidates.some(item => item.candidateId === candidateId);
		return (
			<td align="center" className="kendo-grid-command-cell-content">
				<Checkbox
					checked={isChecked}
					onChange={() => handleCheckboxChange(props)}
					disabled={!isChecked && selectedCandidates.length >= 5}
					size="small"
				/>
			</td>
		);
	};

	const goToDashboard = () => {
		history("/dashboard",
			{
				state: { id: id, recruitmentPartnerId: userRecruitmentpartnerId, userType: userType, userRecords: userRecrodData, userRole: userRole }
			});
	}

	const downloadResume = async (event, url) => {
		window.open(url, "_blank");
	};

	const renderPhoneNumber = (row) => {
		const crd = row?.original.candidateresumedetails || row?.original.candidateRequisitionDetails || {};
		const phoneNumber = crd.phoneNumber;
		const countryCallingCode = crd.countryCallingCode;

		if (!phoneNumber) return <span>N/A</span>;

		const normalizedPhone = normalizePhoneNumber(phoneNumber, countryCallingCode);

		return <span>{normalizedPhone}</span>;
	};


	const callApiToGenerateExcel = async () => {
		setIsExporting(true);

		if (!dataResult || !dataResult[curStatus]) {
			NotificationManager.error("No data available", "Error", 10000);
			setIsExporting(false);
			return;
		}
		const data = dataResult[curStatus].filter((item) => {
			return !filter || item.name.toLowerCase().includes(filter.toLowerCase());
		});

		if (!data || !(data?.length > 0)) {
			NotificationManager.error("No data available", "Error", 10000);
			setIsExporting(false);
			return;
		}
		let eventTitle = title[curStatus] || "Event Date";

		let exportData = data.map(candidate => {
			const startedDate = extractedDate(candidate);
			return {
				"Name": candidate.name,
				"Email": candidate.email,
				"Phone Number": candidate.phoneNumber,
				"Recruiter Name": candidate.recruiterData.displayName,
				"Submitted by": candidate.lastEventStatusCreatedBy.displayName,
				"Updated On": candidate.updated_at,
				[eventTitle]: candidate.eventDate,
				...((curStatus === "CRS04" || curStatus === "CRS014" || curStatus === "CRS015") && { startedDate })
			}
		});
		// Lazy load XLSX only when needed for export
		const { utils, writeFile } = await import("xlsx");
		const ws = utils.json_to_sheet(exportData);

		const wb = utils.book_new();
		utils.book_append_sheet(wb, ws, "Data");
		writeFile(wb, "report details.xlsx");

		setIsExporting(false);
	};
	const title = {
		"CRS03": "Interview Date",
		"CRS010": "Interview Date",
		"CRS012": "Interview Date",
		"CRS04": "Selected Date",
		"CRS06": "Started On",
		"CRS07": "Dropout Date",
		"CRS08": "Withdraw Date",
		"CRS017": "Screen Select Date",
		"CRS018": "L1 Select Date",
		"CRS09": "L1 Reject Date",
		"CRS011": "L2 Reject Date",
		"CRS013": "L3 Reject Date",
		"CRS014": "Offer Extended Date",
		"CRS015": "Offer Accepted Date",
		"CRS019": "L2 Select Date",
		"CRS016": "Screen Reject Date",
		"all": "Date"
	}
	const subTitle = {
		"CRS04": "Start Date",
		"CRS014": "Start Date",
		"CRS015": "Start Date",
	}
	const extractedDate = (dataItem) => {
		const activeStatuses = dataItem?.eventStatus?.filter(status => !status.isDeleted) || [];
		const lastActiveStatus = activeStatuses[activeStatuses.length - 1];
		const startedDate = lastActiveStatus?.activityLogs?.[0]?.startedDate;
		return startedDate
			? startedDate.split("T")[0].replace(/-/g, "/")
			: "NA";
	}
	const customDateStartted = (event) => {
		const extractedtime = extractedDate(event.original)
		return (
			<td>
				<span >{extractedtime}</span>
			</td>
		);
	};

	function dateFilterFn(row, columnId, filterValue) {
		if (!filterValue) return true; // no filter
		const rowValue = row.original[columnId];
		if (!rowValue) return false;

		try {
			const rowDate = new Date(rowValue);
			const filterDate = new Date(filterValue);

			// Reset time to start of day for both dates to compare only date part
			rowDate.setHours(0, 0, 0, 0);
			filterDate.setHours(0, 0, 0, 0);

			return rowDate.getTime() === filterDate.getTime();
		} catch (error) {
			console.warn('Date filtering error:', error);
			return false;
		}
	}

	const getDateFilterValue = (column) => {
		const filterValue = column.getFilterValue();
		return filterValue ? new Date(filterValue) : null;
	}

	const handleRtrRender = (row) => {
		if (row?.original?.candidaterequisitionattachments && Object.keys(row?.original?.candidaterequisitionattachments?.approvalStatus ?? 0).length > 0) {
			if (row.original.candidaterequisitionattachments.approvalStatus.isPending) {
				return <div className="status-container status-pending">
					<Pending />
					<span className="status-text">Awaiting Approval</span>
				</div>
			}
			else if (row.original.candidaterequisitionattachments.approvalStatus.isRejected) {
				return <div className="status-container status-rejected">
					<Rejected />
					<span className="status-text">Candidate Declined</span>
				</div>
			}
			else if (row.original.candidaterequisitionattachments.approvalStatus.isApproved) {
				return <div className='status-container status-approved'>
					<Approved />
					<span className="status-text">RTR Approved</span>
				</div>
			}
			else {
				return "N/A";
			}
		}
		else {
			return "N/A";
		}
	}


	const fromReassignmentChangeHandler = async (value) => {
		let obj = { ...reAssignmentObj };
		if (value) {
			obj.reassginedFrom = value;
			obj.reassginedTo = {};
		} else {
			obj.reassginedFrom = {};
			obj.reassginedTo = {};
		}
		setReAssignmentObj(obj);
	};

	const reassignmentTeamChangeHandler = async (value) => {
		if (value) {
			let recruiterList = value?.recruiter;
			setReAssignmentObj({
				...reAssignmentObj,
				reassignTeam: value,
				reassginedTo: {}
			});
			// Filter out the current recruiter from the reassign-to list
			recruiterList = recruiterList.filter(item => item.id !== reAssignmentObj.reassginedFrom?.id);
			setReassignToRecruiterList(recruiterList || []);
		} else {
			setReAssignmentObj({
				...reAssignmentObj,
				reassignTeam: {},
				reassginedTo: {}
			});
			setReassignToRecruiterList([]);
		}
	};

	const newRecruiterReassignmentChangeHandler = (value) => {
		let obj = { ...reAssignmentObj };
		if (value) {
			obj.reassginedTo = value;
		} else {
			obj.reassginedTo = {};
		}
		setReAssignmentObj(obj);
	};
	
	const handleOpenTransferModal = (candidate) => {
		let normalized = normalizeCandidate(candidate);
		// if we recently updated this candidate locally, prefer that version
		if (
			selectedTransferCandidate &&
			normalized.candidateId === selectedTransferCandidate.candidateId
		) {
			normalized = selectedTransferCandidate;
		}
		setSelectedTransferCandidate(normalized);
		setReAssignmentObj({
			reassginedFrom: normalized?.recruiterData || {},
			reassginedTo: {},
			reassignTeam: {}
		});
		setReassignRecruiterList([normalized?.recruiterData]); // Only current recruiter
		setOpenTransferModal(true);
	};


	const handleCloseTransferModal = () => {
		setOpenTransferModal(false);
		setSelectedTransferCandidate(null);
	};

	const handleSaveTransfer = async () => {
		try {

			if (
				!reAssignmentObj.reassginedFrom?.id ||
				!reAssignmentObj.reassginedTo?.id ||
				!reAssignmentObj.reassignTeam?._id
			) {
				NotificationManager.error("Please fill all fields", "Error", 5000);
				return;
			}

			setIsUserDataUpdating(true);
			const payloadData = {
				oldRecruiterId: reAssignmentObj.reassginedFrom?.id,
				newRecruiterId: reAssignmentObj.reassginedTo?.id,
				oldTeamLeaderId: selectedTransferCandidate?.recruiterrequisitions?.team?.teamLeaderId,
				newTeamLeaderId: reAssignmentObj.reassignTeam?.teamLeaderId,
				oldTeamId: selectedTransferCandidate?.recruiterrequisitions?.team?.teamId,
				newTeamId: reAssignmentObj.reassignTeam?._id,
				candidateRequisitionId: selectedTransferCandidate?._id,
			};

			let payload = {
				transferList: [payloadData],
				userRecruitmentPartnerId: userRecruitmentpartnerId,
				userId: id,
				requisitionDetailId: selectedTransferCandidate?.requisitionDetailId || selectedTransferCandidate?.requisitiondetails?._id,
			}			
			const response = await CandidateOwenershipTransfer(payload);
			if (response.status === 200) {
			    NotificationManager.success("Candidate transferred successfully", "Success", 5000);

                // update our local selected candidate object so subsequent opens show new recruiter
                setSelectedTransferCandidate(prev => {
                    if (!prev) return prev;
                    const updated = {
                        ...prev,
                        recruiterData: reAssignmentObj.reassginedTo || {},
                    };
                    // also update any nested recruiterrequisitions info if present
                    if (updated.recruiterrequisitions) {
                        updated.recruiterrequisitions = {
                            ...updated.recruiterrequisitions,
                            recruiterId: reAssignmentObj.reassginedTo?.id || updated.recruiterrequisitions.recruiterId
                        };
                    }
                    return updated;
                });

                // prepare for next open: current assigned becomes the only option
                setReassignRecruiterList([reAssignmentObj.reassginedTo]);
                setReAssignmentObj({
                    reassginedFrom: reAssignmentObj.reassginedTo || {},
                    reassginedTo: {},
                    reassignTeam: {}
                });

                // close modal and refresh search results immediately
                setOpenTransferModal(false);
                debouncedSearch(id, userType, requi);
            }
			setIsUserDataUpdating(false);

		} catch (error) {
			NotificationManager.error("Error transferring candidate", "Error", 5000);
			setIsUserDataUpdating(false);
		}
	};

	const canTransfer =
		userType === "MIS Operator" ||
		userType === "Organization Admin" ||
		(userType === "Admin" &&
			(userRole === "MIS Operator" || userRole === "Organization Admin"));

	const columns = [
		{
			id: "action",
			header: "Action",
			cell: ({ row }) => handleCandidateLink_candidatesearch(row),
			size: 100,
			enableSorting: false,
		},
		{
			id: "Document",
			header: "Document",
			size: 100,
			enableSorting: false,
			cell: ({ row }) => {
				const resumeLinks = row?.original?.resumeLink ?? [];
				const latestResume = resumeLinks[resumeLinks.length - 1];
				const link = latestResume?.link;

				const extension = link?.slice(-4).toLowerCase();
				const isDoc = extension === "docx" || extension?.slice(-3) === "doc";
				const isPdf = extension?.slice(-3) === "pdf";

				return (
					<div
						className="activityInviteBtnAllignment cp"
						onClick={(e) => downloadResume(e, link)}
					>
						{isDoc ? (
							<img src={docIcon} alt="doc-icon" />
						) : isPdf ? (
							<img src={pdfIcon} width="39px" alt="pdf-icon" />
						) : (
							"N/A"
						)}
					</div>
				);
			},
		},
		{
			accessorKey: "name", header: "Name", size: 150,
			enableSorting: true,
			enableColumnFilter: true,
			filterFn: 'includesString',
		},
		{
			accessorKey: "email", header: "Email", size: 300,
			enableSorting: true,
			enableColumnFilter: true,
			filterFn: 'includesString',
		},
		{
			id: "phoneNumber",
			header: "Phone",
			size: 150,
			cell: ({ row }) => renderPhoneNumber(row),
			enableSorting: true,
			enableColumnFilter: true,
			filterFn: (row, columnId, filterValue) => {
				if (!filterValue) return true;
				const phoneNumber = row.original.phoneNumber;
				const countryCallingCode = row.original.countryCallingCode;
				const normalizedPhone = normalizePhoneNumber(phoneNumber, countryCallingCode);
				return normalizedPhone.toLowerCase().includes(filterValue.toLowerCase());
			},
			accessorFn: (row) => {
				const normalizedPhone = normalizePhoneNumber(row.phoneNumber, row.countryCallingCode);
				return normalizedPhone;
			},
		},
		{
			accessorKey: "recruiterData.displayName", header: "Recruiter Name", size: 150,
			enableSorting: true,
			enableColumnFilter: true,
			filterFn: 'includesString',
		},
		{
			accessorKey: "lastEventStatusCreatedBy.displayName", header: "Submitted by", size: 150,
			enableSorting: true,
			enableColumnFilter: true,
			filterFn: 'includesString',
		},
		{
			accessorKey: "rtrStatus",
			cell: ({ row }) => {
				return handleRtrRender(row)
			},
			header: "RTR Status",
			size: 210,
			enableColumnFilter: false,
		},
		{
			accessorKey: 'rtrLastUpdatedOn',
			header: 'RTR Timestamp',
			size: 150,
			cell: ({ row }) => {
				return <span>{calculateDaysSinceUpdate(row)}</span>;
			},
			enableSorting: false,
			enableColumnFilter: false,
		},
		// {
		// 	accessorKey: "updated_at", header: "Updated On", size: 150,
		// 	enableColumnFilter: true,
		// 	filterFn: dateFilterFn,
		// 	Filter: ({ column }) => (
		// 		<div className="date-picker-filter-container">
		// 			<DatePicker
		// 				selected={getDateFilterValue(column)}
		// 				onChange={(date) => {
		// 					column.setFilterValue(date ? date.toISOString() : '');
		// 				}}
		// 				dateFormat="MM/dd/yyyy"
		// 				placeholderText="Select date"
		// 				isClearable
		// 				showIcon={true}
		// 				className="date-picker-table-filter"
		// 			/>
		// 		</div>
		// 	),
		// 	// enableSorting: true,
		// 	// enableColumnFilter: true,
		// 	// filterFn: 'includesString', 
		// },
		...(title[curStatus]
			? [{
				accessorKey: "eventDate", header: title[curStatus], size: 150,
				enableSorting: true,
				enableColumnFilter: true,
				filterFn: dateFilterFn,
				Filter: ({ column }) => (
					<div className="date-picker-filter-container">
						<DatePicker
							selected={getDateFilterValue(column)}
							onChange={(date) => {
								column.setFilterValue(date ? date.toISOString() : '');
							}}
							dateFormat="MM/dd/yyyy"
							placeholderText="Select date"
							isClearable
							showIcon={true}
							className="date-picker-table-filter"
						/>
					</div>
				),
			},] : []),
		...(subTitle[curStatus]
			? [{
				id: "date", header: subTitle[curStatus], size: 150,
				cell: ({ row }) => customDateStartted(row),
				enableSorting: true,
				enableColumnFilter: true,
				filterFn: dateFilterFn,
				Filter: ({ column }) => (
					<div className="date-picker-filter-container">
						<DatePicker
							selected={getDateFilterValue(column)}
							onChange={(date) => {
								column.setFilterValue(date ? date.toISOString() : '');
							}}
							dateFormat="MM/dd/yyyy"
							placeholderText="Select date"
							isClearable
							showIcon={true}
							className="date-picker-table-filter"
						/>
					</div>
				),
			},] : []),
			...(canTransfer
			? [{
				id: "customButton",
				header: "Transfer Candidate",
				size: 180,
				enableSorting: false,
				enableColumnFilter: false,
				
				cell: ({ row }) => (
					<button
						className="transfer_button"
						disabled={row.original?.requisitiondetails?.status?.statusCode === config.requisitionStatusCodes.FILLED}
						onClick={() => {
							handleOpenTransferModal(row.original);
						}}
					>
						Transfer
					</button>
				),
			}]
			: []),
	]


	return (
		<>
			{userType !== "Candidate" ? (
				<>
					<Backdrop
						sx={stylesSx.backdrop}
						open={isExporting}
					>
						<CircularProgress color="inherit" />
						<Typography sx={stylesSx.waitingText}> Please wait ...</Typography>
					</Backdrop>


					<div className='mainContainer_activity'>
						<div className='topContainer_activity'>
							<Grid container>
								<Grid size={{ xs: 12 }}>
									<Header />
								</Grid>
							</Grid>
							<div className="mainDiv_activity">
								<div className="activityHeader">
									<div className="goBackButton_activity" onClick={(e) => goToDashboard(e)}>
										<Tooltip title="Go Back to Dashboard" placement="bottom">
											<ArrowBackIcon sx={{ fontSize: 20 }} />
										</Tooltip>
									</div>
									<div className="activityTitle">Activity : {codeTofield(curStatus) || "ALL"}</div>
									<button className='excelButton_act'
										onClick={callApiToGenerateExcel}
									>
										<ExcelIcon />

										<span>Export</span></button>
									{selectedCandidates.length > 0 && (
										<button className="selectedListBtn_act" onClick={handleDrawerOpen}>
											<span>
												<SelectList />
											</span>
											Selected List ({selectedCandidates.length})
										</button>
									)}
								</div>
								<div className="interview_mainCont_activity">
									<div className="activity_topCon">
										<div className="KendoContainer_Activity">
											<DataTable
												data={
													dataResult && dataResult[curStatus]?.length > 0
														? dataResult[curStatus]
															.filter(item =>
																!filter || item.name?.toLowerCase().includes(filter.toLowerCase())) : []}
												columns={columns}
												isLoading={isloading}
											/>

										</div>
										<div className="activity_rightCon">
											<RecentActivities activity={true} requisitionId={requi} idContextTest={id} userType={userType} userRecords={userRecrodData} userRole={userRole} userRecruitmentpartnerId={userRecruitmentpartnerId} isSearching={isSearching}
												curStatus={curStatus}
												setCurStatus={setCurStatus}
												setCounts={setCounts}
												counts={counts}
												activCount={activCount}
												setactivCount={setactivCount}
											/>
										</div>
									</div>
								</div>
							</div>

							<Drawer
								anchor="right"
								open={drawerOpen}
								onClose={handleDrawerClose}
								PaperProps={{ sx: { width: 350, display: 'flex', flexDirection: 'column' } }}
							>
								<div style={{ display: 'flex', alignItems: 'center', padding: '16px', borderBottom: '1px solid #eee' }}>
									<Typography variant="h6" style={{ flex: 1 }}>Selected Candidates</Typography>
									<IconButton onClick={handleDrawerClose}>
										<CloseIcon />
									</IconButton>
								</div>
								<List sx={{ flex: 1, overflowY: 'auto', bgcolor: '#f9f9f9' }}>
									{selectedCandidates?.length === 0 ? (
										<ListItem>
											<ListItemText primary="No candidates selected." />
										</ListItem>
									) : (
										selectedCandidates.map((candidate, idx) => (
											<CandidateCard
												key={candidate.candidateId || candidate._id || idx}
												candidate={candidate}
												onRemove={handleRemoveCandidate}
											/>
										))
									)}
								</List>
								<div style={{ padding: 16, borderTop: '1px solid #eee' }}>
									<Button
										variant="contained"
										color="primary"
										fullWidth
										disabled={selectedCandidates?.length === 0}
										onClick={handleBulkSubmit}
									>
										{selectedCandidates?.length > 1 ? 'Bulk Action' : 'Action'}
									</Button>
								</div>
							</Drawer>
							{openBukSubmitModal && (
								<BulkSubmitModal
									openBukSubmitModal={openBukSubmitModal}
									setOpenBukSubmitModal={setOpenBukSubmitModal}
									candidateList={selectedCandidates.map(normalizeCandidate)}
									setCandidateList={setSelectedCandidates}
									userType={userType}
									userId={id}
									recruitmentpartnerId={userRecruitmentpartnerId}
									requisitionId={requi}
									sourcePage="Activity"
									moveCandidate={moveCandidate}
								/>
							)}
						</div>
					</div>

					{openTransferModal && (
						<RecruiterReassignmentModel
							open={openTransferModal}
							onClose={handleCloseTransferModal}
							onSave={handleSaveTransfer}
							userType={userType}
							isUserDataUpdating={isUserDataUpdating}
							reassignRecruiterList={reassignRecruiterList}
							reassignToRecruiterList={reassignToRecruiterList}
									reAssignmentObj={reAssignmentObj}
							fromReassignmentChangeHandler={fromReassignmentChangeHandler}
							newRecruiterReassignmentChangeHandler={newRecruiterReassignmentChangeHandler}
							reassignmentTeamChangeHandler={reassignmentTeamChangeHandler}
							userRecruitmentpartnerId={userRecruitmentpartnerId}
							selectedTeam={{}}
							requisitionDetailId={selectedTransferCandidate?.requisitionDetailId}
				
							source="Activity"
						/>
					)}
				</>
			)

				: (<UnauthorizedAccess />)
			}
		</>
	)
}

export default Activity;


